export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            有好看的剧想推荐？发现了最新的电影上映资讯？或者对久久影视有任何建议——
            欢迎通过以下方式联系我们，一起让追剧变得更简单。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              投稿 / 推荐剧集
            </a>
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line"></i>
              查看常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}